import { Component, Directive, EventEmitter, HostBinding, Input, OnInit, Optional, Output, ViewChild } from '@angular/core';
import { UntypedFormControl, Validators, UntypedFormGroup, UntypedFormBuilder, ControlContainer } from '@angular/forms';
import { MatTabsModule } from '@angular/material/tabs';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort, Sort } from "@angular/material/sort";
import { Contract } from 'src/app/model/contract';
import { Company } from 'src/app/model/company';
//import {BillingItems} from "../../../model/billing-Setup";
import { BillingSetupService } from "../../../services/billing-setup.service";
import { BillingSetup } from 'src/app/model/billingSetup';
import { BillingSetupItemArray } from 'src/app/model/billingSetupItemArray';
import { BillingItems } from 'src/app/model/billingItems';
import { merge } from 'lodash-es';
import { PublicService } from 'src/app/services/public.service';
import { SnackService } from 'src/app/services/snack.service';
import { environment } from 'src/environments/environment';
import { Researcher } from 'src/app/model/researcher';
import { BillingItemsArray } from 'src/app/model/billingItemsArray';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';

@Component({
  selector: 'aw-setup',
  templateUrl: './setup.component.html',
  styleUrls: ['./setup.component.scss'],
  providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { showError: true },
    },
  ]
})
export class BillingSetupComponent implements OnInit {

  @ViewChild(MatPaginator, { static: true })
  paginator!: MatPaginator;
  @Output() saved = new EventEmitter<void>();
  @Output() canceled = new EventEmitter<void>();
  saving = false;
  contracts: Contract[] = [];
  contract = new Contract;
  items: BillingItems[] = [];
  researchers: Researcher[] = [];
  box: BillingItems[] = [];
  company = new Company;
  contractCustomer = new Contract;
  companyCustomer = new Company;
  @Input() isRegistrationRequest = false;
  // billingIdContractForm: FormGroup;
  billingSetupForm: UntypedFormGroup;
  billingItemsForm: UntypedFormGroup;
  billingPeriodForm: UntypedFormGroup;
  billingSetupCustomerForm: UntypedFormGroup;
  recaptchaKey = environment.captchaKey;
  result!: Array<BillingItemsArray>;
  billingItemsCustomerForm!: Array<BillingItemsArray>;
  statusMessage!: string;
  billingItemsById: BillingItems[] = [];
  maxBox = 0;
  maxResearcher = 0;


  public headers = [

    'billingItemType',
    'units',
    'unitCost',
    'invoicePeriod',
    'Change'
    // 'action'
  ];

  disabled = false;
  hideElement = true;
  // disabledItemId: number[] = [];
  loading = false;
  // dataSource: any[] = [];
  dataSource!: MatTableDataSource<BillingItems>;

  private _liveAnnouncer: any;
  // billingItemsCustomerForm!: FormArray;
  // billingItemCustomerForm!: FormGroup;

  partnerContracts: Contract[] = [];

  customerContracts: Contract[] = [];

  constructor(
    public tabGroup: MatTabsModule,
    private billingSetupService: BillingSetupService,
    private _formBuilder: UntypedFormBuilder,
    public snackBarService: SnackService,
    public snackBar: MatSnackBar,
    private router: Router,
  ) {
    this.result = new Array<BillingItemsArray>();

    this.billingSetupForm = this._formBuilder.group(
      {
        addressLine1: new UntypedFormControl(
          '',
          [
            Validators.required
          ]
        ),
        city: new UntypedFormControl(
          '',
          [
            Validators.required
          ]
        ),
        codeSDI: new UntypedFormControl(
          '',
          [
            Validators.required
          ]
        ),
        country: new UntypedFormControl(
          '',
          [
            Validators.required
          ]
        ),
        description: new UntypedFormControl(
          '',
          [
          ]
        ),
        email: new UntypedFormControl(
          '',
          [
            Validators.required,
            Validators.email
          ]
        ),
        identifier: new UntypedFormControl(
          '',
          [
            Validators.required
          ]
        ),
        pec: new UntypedFormControl(
          '',
          [
            // Validators.required,
            Validators.email
          ]
        ),
        phone: new UntypedFormControl(
          '',
          [
            // Validators.required
          ]
        ),
        vatNumber: new UntypedFormControl(
          '',
          [
            Validators.required
          ]
        ),
        zipCode: new UntypedFormControl(
          '',
          [
            Validators.required
          ]
        ),
        month: new UntypedFormControl(
          '',
          [
            Validators.required
          ]
        ),
        type: new UntypedFormControl(
          '',
          [
            Validators.required
          ]
        )

      }
    );
    this.billingItemsForm = this._formBuilder.group(
      {
        billingItemType: new UntypedFormControl(
          3,
          [
          ]
        ),
        description: new UntypedFormControl(
          '',
          [
            Validators.required
          ]
        ),
        percentage: new UntypedFormControl(
          '',
          [
            Validators.required
          ]
        )
      }
    );
    this.billingPeriodForm = this._formBuilder.group(
      {
        month: new UntypedFormControl(
          '',
          [
            Validators.required
          ]
        ),
        type: new UntypedFormControl(
          '',
          [
            Validators.required
          ]
        )
      }
    );
    this.billingSetupCustomerForm = this._formBuilder.group(
      {
        addressLine1: new UntypedFormControl(
          '',
          [
            Validators.required
          ]
        ),
        addressLine2: new UntypedFormControl(
          '',
          [
          ]
        ),
        city: new UntypedFormControl(
          '',
          [
            Validators.required
          ]
        ),
        codeSDI: new UntypedFormControl(
          '',
          [
            Validators.required
          ]
        ),
        country: new UntypedFormControl(
          '',
          [
            Validators.required
          ]
        ),
        description: new UntypedFormControl(
          '',
          [
          ]
        ),
        email: new UntypedFormControl(
          '',
          [
            Validators.required,
            Validators.email
          ]
        ),
        identifier: new UntypedFormControl(
          '',
          [
            Validators.required
          ]
        ),
        pec: new UntypedFormControl(
          '',
          [
            Validators.email
          ]
        ),
        phone: new UntypedFormControl(
          '',
          [
          ]
        ),
        vatNumber: new UntypedFormControl(
          '',
          [
            Validators.required
          ]
        ),
        zipCode: new UntypedFormControl(
          '',
          [
            Validators.required
          ]
        )

      }
    );

  }

  @ViewChild(MatSort)
  sort!: MatSort;
  _items = new BillingSetupItemArray();


  ngOnInit() {


    if (this.isRegistrationRequest) {
      this.billingSetupForm.addControl('recaptchaReactive', new UntypedFormControl(null, Validators.required));
      this.billingItemsForm = this._formBuilder.group({
        secondCtrl: ['', Validators.required],
      });
      this.billingSetupCustomerForm = this._formBuilder.group({
        firstCtrl: ['', Validators.required],
      });
    }


    // this.patch();
    // this.billingSetupService.getAllContracts(
    // )
    //   .subscribe(res => {
    //     this.contracts = res;
    //     console.log(this.contracts); 
    //   });

    this.billingSetupService.getAllPartnerContracts(
    )
      .subscribe(res => {
        this.partnerContracts = res;
        //console.log(this.contracts);
      });

    this.billingSetupService.getAllCustomerContracts(
    )
      .subscribe(res => {
        this.customerContracts = res;
        //console.log(this.contracts);
      });
  }

  announceSortChange(sortState: Sort) {
    // This example uses English messages. If your application supports
    // multiple language, you would internationalize these strings.
    // Furthermore, you can customize the message to add additional
    // details about the values being sorted.
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }

  selectContract(deviceValue: any) {
    console.log("select" + deviceValue)
    this.billingSetupService.getContractById(
      deviceValue
    )
      .subscribe(res => {
        this.contract = res;
        console.log("contract", this.contract);
        const company = this.contract.company;
        if (company != undefined) {
          this.company = company;
        }

        console.log(company)
      });


  }


  disabledRow: boolean[] = [];

  selectContractCustomer(idContractCustomer: any) {
    this.billingItemsCustomerForm = [];
    console.log("select" + idContractCustomer);
    this.disabledRow = [];
    this.result = [];
    this.billingSetupService.getContractById(
      idContractCustomer
    )
      .subscribe(res => {
        this.contractCustomer = res;
        console.log("contract", this.contractCustomer);
        const companyCustomer = this.contractCustomer.company;
        if (companyCustomer != undefined) {
          this.companyCustomer = companyCustomer;
        }

      });

    this.billingSetupService.getAllResearcherContractById(
      idContractCustomer
    )
      .subscribe(res => {

        if (typeof res.units != "undefined" && res.units) {
          this.result.push(res);
          console.log('result setup', this.result);
          this.dataSource = new MatTableDataSource(this.result);
          this.maxResearcher = res.units;
          this.dataSource.paginator = this.paginator;
        }
        console.log("result", this.result);

        if (typeof (this.dataSource.data) !== 'undefined' && this.dataSource.data !== undefined && this.dataSource.data.length > 0) {
          let disablecRowLength = this.dataSource.data.length;
          console.log("length", disablecRowLength);
          for (let i = 0; i < disablecRowLength; i++) {
            this.disabledRow[i] = true;
            console.log(this.disabledRow);
          }
        }

        console.log("dataSourceResearcher", this.dataSource)
      });

    const status = ["available"];

    this.billingSetupService.getAllItemsDeliveredByContract(
      idContractCustomer, status
    )
      .subscribe(res => {
        console.log("resBox", res);
        // this.result = [res];

        if (typeof res.units != "undefined" && res.units) {
          this.result.push(res);
          this.dataSource = new MatTableDataSource(this.result);
          this.maxBox = res.units;
          this.dataSource.paginator = this.paginator;
        }
        console.log("resultBox", this.result);
        if (typeof (this.dataSource.data) !== 'undefined' && this.dataSource.data !== undefined && this.dataSource.data.length > 0) {
          let disablecRowLength = this.dataSource.data.length;
          console.log("length", disablecRowLength);
          for (let i = 0; i < disablecRowLength; i++) {
            this.disabledRow[i] = true;
            console.log(this.disabledRow);
          }
        }

        console.log("dataSource", this.dataSource)
        console.log("units", this.units);
      });

  }


  addItemCostumerSetup(result: BillingItems) {
    console.log('sono edituser', result);

    if (typeof result !== "undefined" && typeof result.units != "undefined" && result.units > 0) {
      for (let index in this.billingItemsCustomerForm) {
        console.log("billingItem ", index);
        let prop = this.billingItems;
        prop = this.billingItemsCustomerForm[index];
        if (result.billingItemsType === prop.billingItemsType) {
          this.billingItemsCustomerForm.splice(Number(index), 1);
        }

      }
      let pippo = result;
      console.log(pippo);
      this.billingItemsCustomerForm.push(pippo);
      console.log(this.billingItemsCustomerForm);
      this.statusMessage = 'Item is saved';
      this.snackBarService.success(this.statusMessage);
    }
    if (typeof result !== "undefined" && typeof result.units != "undefined" && result.units == 0) {
      for (let index in this.billingItemsCustomerForm) {
        console.log("billingItem ", index);
        let prop = this.billingItems;
        prop = this.billingItemsCustomerForm[index];
        if (result.billingItemsType === prop.billingItemsType) {
          this.billingItemsCustomerForm.splice(Number(index), 1);
          this.statusMessage = 'Item is deleted';
          this.snackBarService.success(this.statusMessage);
        }
        else {
          this.statusMessage = 'Item Units must be > 0';
          this.snackBarService.error(this.statusMessage);
        }

      }


    }

  }



  //Form field with error messages
  billingItemType = new UntypedFormControl('', [Validators.required]);

  getErrorMessage() {
    return this.billingItemType.hasError('required') ? 'You must enter a value' :
      this.billingItemType.hasError('billingItemType') ? 'Not a valid billingItemType' : '';
  }

  units = new UntypedFormControl('', [Validators.required]);

  getErrorMessageUnits() {
    return this.units.hasError('required') ? 'You must enter a value' :
      this.units.hasError('units') ? 'Not a valid units' : '';
  }

  unitCost = new UntypedFormControl('', [Validators.required]);

  getErrorMessageUnitCost() {
    return this.unitCost.hasError('required') ? 'You must enter a value' :
      this.unitCost.hasError('units') ? 'Not a valid unit Cost' : '';
  }

  invoicePeriod = new UntypedFormControl('', [Validators.required]);

  getErrorMessageIvoicePeriod() {
    return this.invoicePeriod.hasError('required') ? 'You must enter a value' :
      this.invoicePeriod.hasError('units') ? 'Not a valid units' : '';
  }

  // serve per fare binding nel form partner
  _billingSetup = new BillingSetup();

  @Input() set billingSetup(value: BillingSetup) {
    this._billingSetup = merge(new BillingSetup(), value);
    this.billingSetupForm.patchValue(this._billingSetup);
  }

  _billingItems = new BillingItems();

  @Input() set billingItems(value: BillingItems) {
    this._billingItems = merge(new BillingItems(), value);
    this.billingItemsForm.patchValue(this._billingItems);
  }

  _billingSetupCustomer = new BillingSetup();

  @Input() set billingSetupCustomer(value: BillingSetup) {
    this._billingSetupCustomer = merge(new BillingSetup(), value);
    this.billingSetupCustomerForm.patchValue(this._billingSetupCustomer);
  }


  saveBillingSetup(): void {
    console.log("form:", this.billingSetupForm.value.addressLine1);
    const newBillingSetup = merge(new BillingSetup(), this._billingSetup, this.billingSetupForm.value);
    const newBillingItems = merge(new BillingItems(), this._billingItems, this.billingItemsForm.value);
    console.log(newBillingItems.billingItemType)
    const contractId = this.contract.id;
    this.billingSetupService.createBillingSetup(newBillingSetup, newBillingItems, contractId).subscribe(res => {
      console.log(res);
      this.openSnackBarSave('Billing setup created!', "Success");
    });

  }

  saveBillingSetupCustomer(): void {
    this.saving = true;
    console.log("form:", this.billingSetupCustomerForm.value.addressLine1);
    const newBillingSetupCustomer = merge(new BillingSetup(), this._billingSetupCustomer, this.billingSetupCustomerForm.value);
    // const newBillingItemsCustomer = merge(new BillingItems(), this._billingItemsCustomer, this.billingItemCustomerForm.value);
    console.log(this.billingItemsCustomerForm)
    // const newBillingSetupItemsCustomerArray = merge(new BillingSetupItemArray(), newBillingSetupCustomer, newBillingItemsCustomer);
    const contractId = this.contractCustomer.id;
    this.billingSetupService.createBillingCustomerSetup(newBillingSetupCustomer, this.billingItemsCustomerForm, contractId)
      .subscribe(res => {
        this.saving = false;
        console.log(res);
        this.openSnackBarSave('Billing setup created!', "Success");
        this.saved.emit();
      });

  }

  openSnackBarSave(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3000,
    }).afterDismissed().subscribe(() => {
      this.router.navigate(['reserved/billing/items']);
    });
  }

  changeDisabledRow(cont: any): void {
    if (this.disabledRow[cont] == false) {
      this.disabledRow[cont] = true;
    }
    else {
      this.disabledRow[cont] = false;
    }

  }

  copyForm(value: any): void {
    console.log(value);
  }
}

@Directive({
  selector: 'label[controlName]',
})
export class LabelControl {
  @Input()
  controlName!: string;

  constructor(@Optional() private parent: ControlContainer) { }

  @HostBinding('textContent')
  get controlValue() {
    return this.parent ? this.parent!.control!.get(this.controlName)!.value : '';
  }
}